var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_2617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1737 10.8942C13.3025 10.8942 12.4596 10.7525 11.6733 10.4975C11.4254 10.4125 11.1492 10.4762 10.9579 10.6675L9.84583 12.0629C7.84125 11.1067 5.96417 9.30042 4.96542 7.225L6.34667 6.04917C6.53792 5.85083 6.59458 5.57458 6.51667 5.32667C6.25458 4.54042 6.12 3.6975 6.12 2.82625C6.12 2.44375 5.80125 2.125 5.41875 2.125H2.96792C2.58542 2.125 2.125 2.295 2.125 2.82625C2.125 9.40667 7.60042 14.875 14.1737 14.875C14.6767 14.875 14.875 14.4287 14.875 14.0392V11.5954C14.875 11.2129 14.5562 10.8942 14.1737 10.8942Z",
    fill: "#4DA528"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_2617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/Call.b1b4dc186db5edec828ce1e967510b76.svg";
export { ForwardRef as ReactComponent };